import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'reeducacao-alimentar',
    title: 'Reeducação alimentar',
    description: 'Identifique os hábitos alimentares do cliente, preferências e metas para montar um plano sustentável.',
    indicatedFor: 'Nutricionistas',
    stepsCount: 2,
    questionsSummary: ['Hábitos atuais', 'Alimentos preferidos', 'Gatilhos alimentares', 'Meta de longo prazo'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Reeducação alimentar',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Seus hábitos alimentares',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'choices',
                        label: 'Com que frequência você come fora de casa ou pede delivery?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Raramente' },
                                { id: 'opt-2', label: '1–2 vezes por semana' },
                                { id: 'opt-3', label: '3–4 vezes por semana' },
                                { id: 'opt-4', label: 'Todos os dias' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Quais alimentos você não consegue abrir mão?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'Em quais situações você tende a comer em excesso?',
                        description: 'Ex: estresse, ansiedade, social, tédio.',
                        required: false,
                        settings: null,
                    },
                ],
            },
            {
                order: 2,
                title: 'Suas metas',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'text',
                        label: 'Qual é a sua grande meta de saúde para os próximos 6 meses?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: 'Você já tentou fazer dieta ou reeducação alimentar antes?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
